import * as React from 'react';
import { TooltipDesktop, Header4, Paragraph2 } from '@cian/ui-kit';
import { StartSales12 } from '@cian/ui-kit/icons';

import * as styles from './SalesStartTooltip.css';

export const SalesStartTooltip = () => {
  return (
    <TooltipDesktop
      title={
        <>
          <Header4>Старт продаж корпуса</Header4>
          <Paragraph2>Есть выгодные предложения и скидки</Paragraph2>
        </>
      }
      theme="white"
      placement="right-start"
    >
      <span className={styles['icon']}>
        <StartSales12 color="error_100" />
      </span>
    </TooltipDesktop>
  );
};
